/**
 * The eleven Incoterms 2020 rules.
 *
 * One list, shared by the free PO generator on the marketing site and the
 * order wizard inside the app, so a term offered in one place is the same term
 * printed by the other.
 */
export const INCOTERMS = [
  'EXW',
  'FCA',
  'FAS',
  'FOB',
  'CFR',
  'CIF',
  'CPT',
  'CIP',
  'DAP',
  'DPU',
  'DDP',
] as const;

export type Incoterm = (typeof INCOTERMS)[number];
